import { FC } from 'react';

import { useInfoT } from '../../../Info/Info.context';
import { useKitInfoContext } from '../../KitInfo.context';
import { StatusContent } from './StatusContent';

const toUserDetailPage = (id: string) => `/users/${id}`;

export const Status: FC = () => {
	const { kit, components } = useKitInfoContext();
	const t = useInfoT('kit-info');
	const Link = components?.Link ?? 'a';

	// Hover title is web-only, so it lives here and not in the shared StatusContent.
	return (
		<span title={t('status.title', { status: kit.status })} className="contents">
			<StatusContent renderCustodyLink={(userId) => <Link key="0" href={toUserDetailPage(userId)} />} />
		</span>
	);
};
